module.exports = __webpack_public_path__ + "img/compentation_gift_green.589dbcbe.svg";